// Packages and Pricing Constants
export const CONFIG = {
  indxDBVer: 15,
  indxDBName: 'BiziverseIDB',
  cntCstrs: 40000,
  cntCstrsStr: "40,000",
  urlMain: "https://biziverse.com",
  urlDomain: "biziverse",
  bzPrdName: "Biziverse",
  cs0: '0',
  trngURL: 'https://meet.google.com/jcz-cvua-dmx',
  imgServerPath: "https://files.biziverse.com/Files/",
  imgServerAPIPath: "https://files.biziverse.com/",
  imgBZFolder: "Files",
  imgItemsFolder: "Items",
  fbWspConfigID: '1143902423778947',
  defResetEndTID: 7
};

export const REFERRAL_PLANS = {
  7: {
    id: 7,
    days: 7,
    amtAfterDsc: 300,
    amtAfterDscStr: "300",
    perDscStr: "83"
  },
  14: {
    id: 14,
    days: 14,
    amtAfterDsc: 99,
    amtAfterDscStr: "99",
    perDscStr: "88"
  },
  20: {
    id: 20,
    days: 20,
    amtAfterDsc: 99,
    amtAfterDscStr: "99",
    perDscStr: "88"
  },
  18: {
    id: 18,
    days: 18,
    amtAfterDsc: 199,
    amtAfterDscStr: "199",
    perDscStr: "89"
  }
};

export const PAGE_EDITION_MAPPER = {
  gqik: {
    editionIds: [34, 35],
    offersEnabled: true,
    offerCoupons: {
      FLASH_EOD: { couponCode: 'OFRFLASH', couponCodeForWH: 'MTFLASH', planPeriod: 'YY' },
      SUNDAY: { couponCode: 'OFRSUNSPL', couponCodeForWH: 'MTSUNSPL', planPeriod: 'YY' },
      D3: { couponCode: 'OFRSPLLTD', couponCodeForWH: 'MTSPLLTD', planPeriod: 'YY' },
      LD25: { couponCode: 'OFRPLCLR', couponCodeForWH: 'MTPLCLR', planPeriod: 'YY' },
      FDBK_CLRNC: { couponCode: 'OFRFDBK', couponCodeForWH: 'MTFDBK', planPeriod: 'YY' },
    }
  },
  gpower: {
    editionIds: [36],
    offersEnabled: true,
    offerCoupons: {
      FLASH_EOD: { couponCode: 'OFRFLASH', couponCodeForWH: 'MTFLASH', planPeriod: 'YY' },
      SUNDAY: { couponCode: 'OFRSUNSPL', couponCodeForWH: 'MTSUNSPL', planPeriod: 'YY' },
      D3: { couponCode: 'OFRSPLLTD', couponCodeForWH: 'MTSPLLTD', planPeriod: 'YY' },
      LD25: { couponCode: 'OFRPLCLR', couponCodeForWH: 'MTPLCLR', planPeriod: 'YY' },
      FDBK_CLRNC: { couponCode: 'OFRFDBK', couponCodeForWH: 'MTFDBK', planPeriod: 'YY' },
      D15: { couponCode: 'OFRSUNSPL', couponCodeForWH: 'MTSUNSPL', planPeriod: 'YY' }
    }
  },
  gerp: {
    editionIds: [37, 38],
    offersEnabled: false,
    offerCoupons: {
      // add when GERP gets its own offers
    }
  },
};
export const currPage = "GPower" // From GERP -> GPower

export const PACKAGES = {
  // CRM Plans
  10: {
    id: 10,
    name: 'CRM Starter',
    baseAmt: 1500,
    baseAmtStr: "1,500",
    baseAmtYY2Str: "3,000",
    baseAmtYY3Str: "4,500",
    afterDsc: 599,
    afterDscStr: "599",
    discPercent: 60,
    users: 5,
    cpnID: 1135,
    cpnCode: 'AUTOCRM95',
    monthly: {
      baseAmt: 2400,
      baseAmtStr: "2,400",
      afterDsc: 1500,
      afterDscStr: "1,500",
      discPercent: 80,
      cpnID: 1056,
      cpnCode: 'AUTO50CRM'
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  2: {
    id: 2,
    name: 'CRM Gold',
    baseAmt: 6000,
    baseAmtStr: "6,000",
    baseAmtYY2Str: "12,000",
    baseAmtYY3Str: "18,000",
    afterDsc: 4800,
    afterDscStr: "4,800",
    discPercent: 20,
    users: 30,
    cpnID: 0,
    cpnCode: 'AUTOCRMGLD',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  13: {
    id: 13,
    name: 'CRM Starter',
    baseAmt: 1800,
    baseAmtStr: "1,800",
    baseAmtYY2Str: "3,600",
    baseAmtYY3Str: "5,400",
    afterDsc: 900,
    afterDscStr: "900",
    discPercent: 50,
    users: 5,
    cpnID: 0,
    cpnCode: '',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  15: {
    id: 15,
    name: 'CRM Trial',
    baseAmt: 1800,
    baseAmtStr: "1,800",
    afterDsc: 150,
    afterDscStr: "150",
    discPercent: 92,
    users: 5,
    cpnID: 706,
    cpnCode: 'AUTOTRL11',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  25: {
    id: 25,
    name: 'CRM with Billing',
    baseAmt: 3300,
    baseAmtStr: "3,300",
    baseAmtYY2Str: "6,600",
    baseAmtYY3Str: "9,900",
    afterDsc: 2299,
    afterDscStr: "2,299",
    discPercent: 30,
    users: 5,
    cpnID: 0,
    cpnCode: '',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  7: {
    id: 7,
    name: 'ERP+CRM Starter',
    tagline: "Easy ERP for Small Businesses",
    stdAmt: 10000,
    stdAmtStr: "10,000",
    baseAmt: 6000,
    baseAmtStr: "6,000",
    baseAmtYY2Str: "12,000",
    baseAmtYY3Str: "18,000",
    afterDsc: 5400,
    afterDscStr: "5,400",
    discPercent: 10,
    users: 3,
    cpnID: 0,
    cpnCode: 'AUTOBIZ',
    resetConfig: {
      afterDsc: 100,
      afterDscStr: "100",
      cpnCode: 'RNWRSTR11'
    },
    monthly: {
      baseAmt: 1200,
      baseAmtStr: "1,200",
      afterDsc: 1200,
      afterDscStr: "1,200",
      discPercent: 0
    },
    quotas: ["Up to 1000 Leads", "1000 Connections", "1000 Items"],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  8: {
    id: 8,
    name: 'ERP+CRM Gold',
    stdAmt: 20000,
    stdAmtStr: "20,000",
    baseAmt: 12000,
    baseAmtStr: "12,000",
    baseAmtYY2Str: "24,000",
    baseAmtYY3Str: "36,000",
    afterDsc: 9600,
    afterDscStr: "9,600",
    discPercent: 20,
    users: 10,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 2400,
      baseAmtStr: "2,400",
      afterDsc: 2400,
      afterDscStr: "2,400",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  11: {
    id: 11,
    name: 'ERP Silver',
    baseAmt: 5000,
    baseAmtStr: "5,000",
    afterDsc: 2900,
    afterDscStr: "2,900",
    discPercent: 42,
    users: 10,
    cpnID: 944,
    cpnCode: 'AUTOSLVOFR',
    instantDsc: 2100,
    instantDscStr: "2,100",
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  16: {
    id: 16,
    name: 'ERP Trial',
    baseAmt: 1800,
    baseAmtStr: "1,800",
    afterDsc: 180,
    afterDscStr: "180",
    discPercent: 90,
    users: 3,
    cpnID: 729,
    cpnCode: 'AUTOERPTRL11',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  17: {
    id: 17,
    name: 'ERP Gold (10 Users)',
    baseAmt: 4800,
    baseAmtStr: "4,800",
    afterDsc: 999,
    afterDscStr: "999",
    discPercent: 80,
    users: 10,
    cpnID: 1618,
    cpnCode: 'AUTOGLD109',
    monthly: {
      baseAmt: 1200,
      baseAmtStr: "1,200",
      afterDsc: 1200,
      afterDscStr: "1,200",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  14: {
    id: 14,
    name: 'ERP Basics',
    baseAmt: 3000,
    baseAmtStr: "3,000",
    baseAmtYY2Str: "6,000",
    baseAmtYY3Str: "9,000",
    afterDsc: 1800,
    afterDscStr: "1,800",
    discPercent: 40,
    users: 5,
    cpnID: 0,
    cpnCode: '',
    instantDsc: 1800,
    instantDscStr: "1,800",
    monthly: {
      baseAmt: 99,
      baseAmtStr: "99",
      afterDsc: 99,
      afterDscStr: "99",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  18: {
    id: 18,
    name: 'ERP Solo',
    tagline: "Smart Tools for Single User",
    baseAmt: 1800,
    baseAmtStr: "1,800",
    baseAmtYY2Str: "3,600",
    baseAmtYY3Str: "5,400",
    afterDsc: 500,
    afterDscStr: "500",
    discPercent: 72,
    users: 1,
    cpnID: 1413,
    cpnCode: 'AUTOSOL50Y1',
    instantDsc: 1800,
    instantDscStr: "1,800",
    monthly: {
      baseAmt: 1800,
      baseAmtStr: "1,800",
      afterDsc: 1800,
      afterDscStr: "1,800",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  19: {
    id: 19,
    name: 'Business Basics',
    baseAmt: 1200,
    baseAmtStr: "1,200",
    afterDsc: 99,
    afterDscStr: "99",
    discPercent: 94,
    users: 1,
    cpnID: 1208,
    cpnCode: 'AUTOBIZ99',
    instantDsc: 99,
    instantDscStr: "99",
    monthly: {
      baseAmt: 1200,
      baseAmtStr: "1,200",
      afterDsc: 1200,
      afterDscStr: "1,200",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  20: {
    id: 20,
    name: 'Business Pro',
    baseAmt: 3000,
    baseAmtStr: "3,000",
    baseAmtYY2Str: "6,000",
    baseAmtYY3Str: "9,000",
    afterDsc: 1900,
    afterDscStr: "1,900",
    discPercent: 36,
    users: 5,
    cpnID: 1382,
    cpnCode: 'AUTOTMYY1',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  21: {
    id: 21,
    name: 'Business Pro (with Accounts)',
    baseAmt: 6000,
    baseAmtStr: "6,000",
    baseAmtYY2Str: "11,000",
    baseAmtYY3Str: "16,000",
    afterDsc: 3999,
    afterDscStr: "3,999",
    discPercent: 33,
    users: 10,
    cpnID: 0,
    cpnCode: '',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  22: {
    id: 22,
    name: 'Manufacturing Pro',
    baseAmt: 7500,
    baseAmtStr: "7,500",
    baseAmtYY2Str: "15,000",
    baseAmtYY3Str: "22,500",
    afterDsc: 4999,
    afterDscStr: "4,999",
    discPercent: 33,
    users: 20,
    cpnID: 0,
    cpnCode: '',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  23: {
    id: 23,
    name: 'ERP + CRM Pro',
    baseAmt: 5000,
    baseAmtStr: "5,000",
    baseAmtYY2Str: "10,000",
    baseAmtYY3Str: "15,000",
    afterDsc: 2900,
    afterDscStr: "2,900",
    discPercent: 40,
    users: 20,
    cpnID: 0,
    cpnCode: '',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  12: {
    id: 12,
    name: 'Stock Starter',
    baseAmt: 6000,
    baseAmtStr: "6,000",
    afterDsc: 1500,
    afterDscStr: "1,500",
    discPercent: 75,
    users: 10,
    cpnID: 654,
    cpnCode: 'STKMEGA15',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  26: {
    id: 26,
    name: 'Billing',
    baseAmt: 1200,
    baseAmtStr: "1,200",
    baseAmtYY2Str: "2,400",
    baseAmtYY3Str: "3,600",
    afterDsc: 999,
    afterDscStr: "999",
    discPercent: 18,
    users: 3,
    cpnID: 0,
    cpnCode: '',
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  27: {
    id: 27,
    name: 'Sales Tools (1 User)',
    baseAmt: 1500,
    baseAmtStr: "1,500",
    baseAmtYY2Str: "3,000",
    baseAmtYY3Str: "4,500",
    afterDsc: 1100,
    afterDscStr: "1,100",
    discPercent: 25,
    users: 1,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 150,
      baseAmtStr: "150",
      afterDsc: 150,
      afterDscStr: "150",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  28: {
    id: 28,
    name: 'CRM & Sales Tools',
    baseAmt: 1500,
    baseAmtStr: "1,500",
    baseAmtYY2Str: "3,000",
    baseAmtYY3Str: "4,500",
    afterDsc: 900,
    afterDscStr: "900",
    discPercent: 40,
    users: 5,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 125,
      baseAmtStr: "125",
      afterDsc: 125,
      afterDscStr: "125",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  29: {
    id: 29,
    name: 'Business Tools (5 Users)',
    baseAmt: 6500,
    baseAmtStr: "6,500",
    baseAmtYY2Str: "13,000",
    baseAmtYY3Str: "19,500",
    afterDsc: 3900,
    afterDscStr: "3,900",
    discPercent: 39,
    users: 5,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 650,
      baseAmtStr: "650",
      afterDsc: 650,
      afterDscStr: "650",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  30: {
    id: 30,
    name: 'Business Tools',
    baseAmt: 1800,
    baseAmtStr: "1800",
    baseAmtYY2Str: "3,600",
    baseAmtYY3Str: "5,400",
    afterDsc: 1500,
    afterDscStr: "1,500",
    discPercent: 16,
    users: 10,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 150,
      baseAmtStr: "150",
      afterDsc: 150,
      afterDscStr: "150",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  31: {
    id: 31,
    name: 'Advanced Tools',
    baseAmt: 6000,
    baseAmtStr: "6,000",
    baseAmtYY2Str: "12,000",
    baseAmtYY3Str: "18,000",
    afterDsc: 2900,
    afterDscStr: "2,900",
    discPercent: 51,
    users: 20,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 500,
      baseAmtStr: "500",
      afterDsc: 500,
      afterDscStr: "500",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  32: {
    id: 32,
    name: 'ERP Toolkit',
    baseAmt: 1800,
    baseAmtStr: "1,800",
    baseAmtYY2Str: "3,600",
    baseAmtYY3Str: "5,400",
    afterDsc: 1800,
    afterDscStr: "1,800",
    discPercent: 0,
    users: 10,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 99,
      baseAmtStr: "99",
      afterDsc: 99,
      afterDscStr: "99",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  24: {
    id: 24,
    name: 'ERP+CRM Corporate',
    stdAmt: 20000,
    stdAmtStr: "20,000",
    baseAmt: 12000,
    baseAmtStr: "12,000",
    baseAmtYY2Str: "24,000",
    baseAmtYY3Str: "36,000",
    afterDsc: 12000,
    afterDscStr: "12,000",
    discPercent: 0,
    users: 10,
    cpnID: 0,
    cpnCode: 'EXTRA10',
    monthly: {
      baseAmt: 2400,
      baseAmtStr: "2,400",
      afterDsc: 2400,
      afterDscStr: "2,400",
      discPercent: 0,
      cpnCode: 'EXTRA10MM'
    },
    quotas: ["Up to 100,000 Leads", "10,000 Connections", "10,000 Items"],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  33: {
    id: 33,
    name: 'ERP+CRM Infinity',
    stdAmt: 30000,
    stdAmtStr: "30,000",
    baseAmt: 18000,
    baseAmtStr: "18,000",
    baseAmtYY2Str: "36,000",
    baseAmtYY3Str: "54,000",
    afterDsc: 18000,
    afterDscStr: "18,000",
    discPercent: 0,
    users: 30,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 3600,
      baseAmtStr: "3,600",
      afterDsc: 3600,
      afterDscStr: "3,600",
      discPercent: 0
    },
    quotas: [],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: ""
  },
  34: {
    id: 34,
    name: 'QikERP Silver',
    flashOfferDummyStr: "20,000",
    flashOfferPriceStr: "6,000",
    tagline: "for Ambitious Startups to systematize",
    stdAmt: 10000,
    stdAmtStr: "10,000",
    baseAmt: 6000,
    baseAmtStr: "6,000",
    baseAmtYY2Str: "12,000",
    baseAmtYY3Str: "18,000",
    afterDsc: 6000,
    afterDscStr: "6,000",
    discPercent: 0,
    offerPrices: {
      FLASH_EOD: { wh: '6,000', other: '6,000', std: '10,000' },
      SUNDAY: { wh: '6,000', other: '6,000', std: '10,000' },
      D3: { wh: '6,000', other: '6,000', std: '10,000' },
      OLD_PL: { wh: '6,000', other: '6,000', std: '10,000' },
      FDBK_CLRNC: { wh: '6,000', other: '6,000', std: '10,000' },
      FRESH: { wh: '6,000', other: '6,000', std: '10,000' },
    },
    users: 5,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 6000,
      baseAmtStr: "6,000",
      afterDsc: 6000,
      afterDscStr: "6,000",
      discPercent: 0
    },
    quotas: ["<b>5 Users</b>", "1000 Contacts", "1000 Stock Items", "Single Firm/Company", "Single Branch/GSTIN"],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: "4,200"
  },
  35: {
    id: 35,
    name: 'QikERP Gold',
    flashOfferDummyStr: "40,000",
    flashOfferPriceStr: "12,000",
    tagline: "for Confident Enterprises to scale up",
    stdAmt: 20000,
    stdAmtStr: "20,000",
    baseAmt: 12000,
    offerPrices: {
      FLASH_EOD: { wh: '12,000', other: '12,000', std: '20,000' },
      SUNDAY: { wh: '12,000', other: '12,000', std: '20,000' },
      D3: { wh: '12,000', other: '12,000', std: '20,000' },
      OLD_PL: { wh: '12,000', other: '12,000', std: '20,000' },
      FDBK_CLRNC: { wh: '12,000', other: '12,000', std: '20,000' },
      FRESH: { wh: '12,000', other: '12,000', std: '20,000' },
    },
    baseAmtStr: "12,000",
    baseAmtYY2Str: "24,000",
    baseAmtYY3Str: "36,000",
    afterDsc: 12000,
    afterDscStr: "12,000",
    discPercent: 0,
    users: "Unlimited",
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 12000,
      baseAmtStr: "12,000",
      afterDsc: 12000,
      afterDscStr: "12,000",
      discPercent: 0
    },
    // quotas: ["<b>Unlimited Users</b>", "1,00,000 Leads", "10,000 Customers", "10,000 Stock Items", "Single Firm/Company", "<b>Multiple Branches/GSTINs</b>"],
    quotas: [`<b>Unlimited Users</b> <span>(Desktop + Mobile)</span>`, "1,00,000 Leads", "10,000 Customers", "10,000 Stock Items", "Single Firm/Company", "<b>Multiple Branches/GSTINs</b>"],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: "8,400"
  },
  36: {
    id: 36,
    name: 'QikERP Power',
    flashOfferDummyStr: "10,000",
    flashOfferPriceStr: "3,900",
    offerPrices: {
      FLASH_EOD: { wh: '4,000', other: '4,000', std: '6,000' },
      SUNDAY: { wh: '1,999', other: '4,800', std: '6,000' },
      D3: { wh: '3,900', other: '4,800', std: '6,000' },
      OLD_PL: { wh: '1,999', other: '1,999', std: '6,000' },
      FDBK_CLRNC: { wh: '3,900', other: '4,800', std: '6,000' },
      FDBK_D14SUN: { wh: '1,999', other: '1,999', std: '6,000' },
      FRESH: { wh: '6,000', other: '6,000', std: '10,000' },
      LD25: { wh: '1,999', other: '4,800', std: '6,000' },
      D15: { wh: '1,999', other: '4,800', std: '6,000' },
    },
    tagline: "for Ambitious Startups to systematize",
    stdAmt: 10000,
    stdAmtStr: "10,000",
    baseAmt: 6000,
    baseAmtStr: "6,000",
    baseAmtYY2Str: "12,000",
    baseAmtYY3Str: "18,000",
    afterDsc: 6000,
    afterDscStr: "6,000",
    discPercent: 0,
    users: 5,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 6000,
      baseAmtStr: "6,000",
      afterDsc: 6000,
      afterDscStr: "6,000",
      discPercent: 0
    },
    // quotas: ["<b>Unlimited Users</b>", "10,000 Contacts", "10,000 Stock Items", "multi-GST"],
    quotas: [`<b>Unlimited Users</b> <span>(Desktop + Mobile)</span>`, "10,000 Contacts", "10,000 Stock Items", "Single Firm/Company", "Multiple Branches / GSTINs"],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: "4,200"
  },
  37: {
    id: 37,
    name: 'Udyam Shakti',
    flashOfferDummyStr: "10,000",
    flashOfferPriceStr: "3,900",
    offerPrices: {
      FLASH_EOD: { wh: '4,000', other: '4,000', std: '6,000' },
      SUNDAY: { wh: '1,999', other: '4,800', std: '6,000' },
      D3: { wh: '3,900', other: '4,800', std: '6,000' },
      OLD_PL: { wh: '1,999', other: '1,999', std: '6,000' },
      FDBK_CLRNC: { wh: '3,900', other: '4,800', std: '6,000' },
      FRESH: { wh: '6,000', other: '6,000', std: '10,000' },
      LD25: { wh: '1,999', other: '4,800', std: '6,000' },
    },
    tagline: "for Ambitious Startups to systematize",
    stdAmt: 3000,
    stdAmtStr: "3,000",
    baseAmt: 3000,
    baseAmtStr: "3,000",
    baseAmtYY2Str: "6,000",
    baseAmtYY3Str: "9,000",
    baseAmtAfterDescStr: "1,800",
    baseAmtAfterDesc: 1800,
    afterDsc: 3000,
    afterDscStr: "3,000",
    discPercent: 0,
    users: 5,
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 6000,
      baseAmtStr: "6,000",
      afterDsc: 6000,
      afterDscStr: "6,000",
      discPercent: 0
    },
    // quotas: ["<b>Unlimited Users</b>", "10,000 Contacts", "10,000 Stock Items", "multi-GST"],
    quotas: [`<b>5 Users</b> <span>(Desktop + Mobile)</span>`, "10,000 Contacts", "10,000 Stock Items", "Single Branch / GSTIN"],
    pricingLines: ['5 Users', 'Single Branch / GSTIN',],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: "4,200"
  },
  38: {
    id: 38,
    name: 'Bharat Unlimited',
    flashOfferDummyStr: "10,000",
    flashOfferPriceStr: "3,900",
    offerPrices: {
      FLASH_EOD: { wh: '4,000', other: '4,000', std: '6,000' },
      SUNDAY: { wh: '1,999', other: '4,800', std: '6,000' },
      D3: { wh: '3,900', other: '4,800', std: '6,000' },
      OLD_PL: { wh: '1,999', other: '1,999', std: '6,000' },
      FDBK_CLRNC: { wh: '3,900', other: '4,800', std: '6,000' },
      FRESH: { wh: '6,000', other: '6,000', std: '10,000' },
      LD25: { wh: '1,999', other: '4,800', std: '6,000' },
    },
    tagline: "for Confident Enterprises to scale up",
    stdAmt: 10000,
    stdAmtStr: "10,000",
    baseAmt: 10000,
    baseAmtStr: "10,000",
    baseAmtYY2Str: "20,000",
    baseAmtYY3Str: "30,000",
    baseAmtAfterDescStr: "6,000",
    baseAmtAfterDesc: 6000,
    afterDsc: 10000,
    afterDscStr: "10,000",
    discPercent: 0,
    users: "Unlimited",
    cpnID: 0,
    cpnCode: '',
    monthly: {
      baseAmt: 10000,
      baseAmtStr: "10,000",
      afterDsc: 10000,
      afterDscStr: "10,000",
      discPercent: 0
    },
    // quotas: ["<b>Unlimited Users</b>", "10,000 Contacts", "10,000 Stock Items", "multi-GST"],
    quotas: [`<b>Unlimited Users</b> <span>(Desktop + Mobile)</span>`, "10,000 Contacts", "10,000 Stock Items", "Multiple Branches / GSTINs"],
    pricingLines: ['Unlimited Users', 'Multiple Branches / GSTINs',],
    flashOfferOn: false,
    showStdOffer: false,
    showD1Offer: false,
    flashSaleName: "",
    flashOfrEndDT: null,
    rfdAvl: false,
    woPrice: false,
    sundayOfferPriceStr: "4,200"
  },
};

export const INTEGRATIONS = [
  'IndiaMart', 'JustDial', 'TradeIndia',
  'Meta forms', 'MagicBricks', '99acres',
  'Website API', 'Excel export', 'Gmail'
]

export const COUPONS = {
  // 1: {
  //   id: 1,
  //   code: 'B1Y5XS03',
  //   title: 'Extra 5% off!',
  //   description: 'Get extra 5% off on Starter Edition – 1 Year Plan',
  //   discountPercent: 5,
  //   discountAmount: 300,
  //   editionID: 7,
  //   planYear: 1,
  //   isActive: true
  // },
  // 2: {
  //   id: 2,
  //   code: 'B3Y01XS81',
  //   title: 'Extra 20% off!',
  //   description: 'Enjoy 20% off on Starter Edition – 3 Year Plan',
  //   discountPercent: 20,
  //   discountAmount: 1200,
  //   editionID: 7,
  //   planYear: 3,
  //   isActive: true
  // },
  // 3: {
  //   id: 3,
  //   code: 'B1Y57XC09',
  //   title: 'Extra 7.5% off!',
  //   description: 'Save 7.5% on Corporate Edition – 1 Year Plan',
  //   discountPercent: 7.5,
  //   discountAmount: 900,
  //   editionID: 24,
  //   planYear: 1,
  //   isActive: true
  // },
  // 4: {
  //   id: 4,
  //   code: 'B3Y81XC06',
  //   title: 'Extra 18% off!',
  //   description: 'Grab 18% off on Corporate Edition – 3 Year Plan',
  //   discountPercent: 18,
  //   discountAmount: 6000,
  //   editionID: 24,
  //   planYear: 3,
  //   isActive: true
  // },
  // 5: {
  //   id: 5,
  //   code: 'B1Y57XC09',
  //   title: 'Extra 5% off!',
  //   description: 'Save 5% on QikERP Silver Edition – 1 Year Plan',
  //   discountPercent: 5,
  //   discountAmount: 300,
  //   editionID: 34,
  //   planYear: 1,
  //   isActive: true
  // },
  // 6: {
  //   id: 6,
  //   code: 'B2Y81XC06',
  //   title: 'Extra 10% off!',
  //   description: 'Grab 10% off on QikERP Silver Edition – 2 Year Plan',
  //   discountPercent: 10,
  //   discountAmount: 600,
  //   editionID: 34,
  //   planYear: 2,
  //   isActive: true
  // },
  // 7: {
  //   id: 7,
  //   code: 'B1Y57XC09',
  //   title: 'Extra 5% off!',
  //   description: 'Save 5% on QikERP Gold Edition – 1 Year Plan',
  //   discountPercent: 5,
  //   discountAmount: 450,
  //   editionID: 35,
  //   planYear: 1,
  //   isActive: true
  // },
  // 8: {
  //   id: 8,
  //   code: 'B2Y81XC06',
  //   title: 'Extra 10% off!',
  //   description: 'Grab 10% off on QikERP Gold Edition – 2 Year Plan',
  //   discountPercent: 10,
  //   discountAmount: 900,
  //   editionID: 35,
  //   planYear: 2,
  //   isActive: true
  // }
  9: {
    id: 9,
    code: 'QIK960',
    title: 'Extra ₹ 960 off!',
    description: 'Extra ₹ 960 on QikERP Power Edition - 1 year plan',
    discountPercent: 14,
    discountAmount: 960,
    editionID: 36,
    planYear: 1,
    isActive: true,
    showOfrEndLabel: true,
    showCpnCode: false,
    timedWindow: false,
    cpnFor: 'ALL',
    hideOnDay1: false,
    minDay: 1,
    maxDay: 1,
    startHour: 0,
    endHour: 9,
    morningLabel: 'Offer Ending Soon!',
    case2Window: true,
    case3MinDay: 5
  },
  10: {
    id: 10,
    code: 'QIK500',
    title: 'Extra ₹ 500 off!',
    description: 'Extra ₹ 500 on QikERP Power Edition - 1 year plan',
    discountPercent: 10,
    discountAmount: 500,
    editionID: 36,
    planYear: 1,
    isActive: true,
    showOfrEndLabel: true,
    showCpnCode: false,
    cpnFor: 'ALL',
    hideOnDay1: true,
    maxDay: 4
  },
  // 11: {
  //   id: 11,
  //   code: 'MTFLWLC',
  //   title: 'Flash Sale!',
  //   description: 'Start First Year @ just ₹ 3900 +GST',
  //   discountPercent: 14,
  //   discountAmount: 2100,
  //   editionID: 36,
  //   planYear: 1,
  //   isActive: true,
  //   showOfrEndLabel: true,
  //   extendedTo8PM: true,
  //   showCpnCode: false,
  //   timedWindow: true,
  //   cpnFor: 'META'
  // },
  12: {
    id: 12,
    code: 'AUTOUDY',
    title: 'Extra 40% off!',
    description: 'Grab 40% off on QikERP Gold Edition – 1 Year Plan',
    discountPercent: 40,
    discountAmount: 1200,
    editionID: 37,
    planYear: 1,
    isActive: false,
    default: true
  },
  13: {
    id: 13,
    code: 'AUTOUNL',
    title: 'Extra 40% off!',
    description: 'Grab 40% off on QikERP Gold Edition – 1 Year Plan',
    discountPercent: 40,
    discountAmount: 4000,
    editionID: 38,
    planYear: 1,
    isActive: false,
    default: true
  }
};

export const FEATURES = [
  // 'CRM', 'Quotes', 'Orders', 'Billing', 'E-Way Bill', 'E-Invoice',
  'CRM', 'Quotes', 'Orders', 'Billing', 'E-Invoice',
  'Accounts', 'GSTR1 & 3B', 'Recovery', 'Inventory', 'Batches', 'BOM',
  'Purchase Orders', 'Suppliers Invoices', 'Manufacturing', 'MRP', 'Projects',
  'Tasks', 'Support Ticketing', 'Contracts'
]

export const UPGRADE_SUBSCRIPTIONS = {
  2: {
    id: '2',
    editionID: 2,
    title: 'Upgrade to CRM Gold',
    description: 'Leads (1,00,000), Integration (IndiaMart, JustDial, TradeIndia, Facebook Lead import), Connections (10,000), Order Tracking, GST Billing, Payment Recovery, Support Ticketing, FREE Upgrades, Training Webinars, Website API access. 30 Users included.',
    baseAmount: PACKAGES[2].baseAmt
  },
  7: {
    id: '7',
    editionID: 7,
    title: 'Upgrade to ERP Starter',
    description: 'Software Tools to manage Leads (10,000), Connections (1000), Quotes, Orders, Billing, Support Ticketing, Inventory (1000 items), Manufacturing, Tasks, Accounts. 10 Users included.',
    baseAmount: PACKAGES[7].baseAmt
  },
  8: {
    id: '8',
    editionID: 8,
    title: 'Upgrade to ERP Gold',
    description: 'Software Tools to manage Leads (1,00,000), Connections (10,000), Quotes, Orders, Billing, Support Ticketing, Inventory (10,000 items), Manufacturing, Tasks, Accounts. 20 Users included.',
    baseAmount: PACKAGES[8].baseAmt
  },
  24: {
    id: '24',
    editionID: 24,
    title: 'Upgrade to ERP Corporate',
    description: 'Software Tools to manage Leads (10,000), Connections (10,000), Quotes, Orders, Billing, Support Ticketing, Inventory (10,000 items), Manufacturing, Tasks, Accounts. 10 Users included.',
    baseAmount: PACKAGES[24].baseAmt
  },
  33: {
    id: '33',
    editionID: 33,
    title: 'Upgrade to ERP Infinity',
    description: 'Software Tools to manage Leads (1,00,000), Connections (20,000), Quotes, Orders, Billing, Support Ticketing, Inventory (1,00,000 items), Manufacturing, Tasks, Accounts. Unlimited Users included.',
    baseAmount: PACKAGES[33].baseAmt
  },
  51: {
    id: '51',
    title: 'Add 10 Users Quota',
    description: '10 Users with Roles',
    baseAmount: 1500
  },
  52: {
    id: '52',
    title: 'Add 10,000 Leads Quota',
    description: '10,000 Extra Leads Quota',
    baseAmount: 1500
  },
  53: {
    id: '53',
    title: 'Add 1000 Connections Quota',
    description: '1000 Extra Connections Quota',
    baseAmount: 1500
  },
  54: {
    id: '54',
    title: 'Add 1000 Stock Items Quota',
    description: '1000 Extra Stock Items Quota',
    baseAmount: 1500
  }
};

export const getEdition = (editionID) => {
  return PACKAGES[editionID] || null;
};

export const getLowestPricedEdition = (pageName) => {
  if (!pageName || !PAGE_EDITION_MAPPER[pageName.toLowerCase()]) {
    return null;
  }

  const pageConfig = PAGE_EDITION_MAPPER[pageName.toLowerCase()];
  const pageEditions = pageConfig.editionIds.map(id => PACKAGES[id]).filter(Boolean);

  return pageEditions.reduce((lowest, edition) => {
    if (!lowest || edition.baseAmt < lowest.baseAmt) {
      return edition;
    }
    return lowest;
  }, null);
};

export const getCoupon = (couponID) => {
  return COUPONS[couponID] || null;
};

export const getCouponsByEdition = (editionID) => {
  return Object.values(COUPONS).filter(coupon => coupon.editionID === editionID);
};

export const getUpgradeOptions = () => {
  return Object.values(UPGRADE_SUBSCRIPTIONS);
};

export const getUpgradesByEdition = (editionID) => {
  return Object.values(UPGRADE_SUBSCRIPTIONS).filter(upgrade => upgrade.editionID === editionID);
};

// Returns { displayPrice, stdPrice } for a given edition + active offer
// displayPrice = offer price to show big, stdPrice = strikethrough (always stdAmtStr)
export const getPageActiveOffer = (pageName, forceOfferKey = null) => {
  const { getActiveOffer, OFFER_RULES } = require('../Utils/OfferEngine');
  const pageConfig = PAGE_EDITION_MAPPER[pageName?.toLowerCase()];
  const pageOffersEnabled = pageConfig?.offersEnabled ?? true;
  if (!pageOffersEnabled) return null;

  let resolvedOffer = forceOfferKey
    ? (() => {
      const rule = OFFER_RULES.find(r => r.offerKey === forceOfferKey);
      if (!rule) return getActiveOffer();
      const allDataRaw = localStorage.getItem('allData');
      let isWHFB = false;
      if (allDataRaw) {
        try {
          const allData = JSON.parse(allDataRaw);
          const source = (allData?.source || '').toUpperCase();
          isWHFB = source.startsWith('FB_') || source.endsWith('_WH');
        } catch { }
      }
      return {
        ...rule,
        isWHFB,
        couponCode: isWHFB && rule.couponCodeForWH ? rule.couponCodeForWH : rule.couponCode,
      };
    })()
    : getActiveOffer();

  if (!resolvedOffer) return null;
  const pageCoupon = pageConfig?.offerCoupons?.[resolvedOffer.offerKey];
  if (!pageCoupon) return resolvedOffer;
  return {
    ...resolvedOffer,
    couponCode: resolvedOffer.isWHFB && pageCoupon.couponCodeForWH
      ? pageCoupon.couponCodeForWH
      : pageCoupon.couponCode,
    planPeriod: pageCoupon.planPeriod ?? resolvedOffer.planPeriod,
  };
};

// --- Find getOfferPrice and replace with this comprehensive helper ---

/**
 * The ultimate source of truth for Edition pricing display.
 * Handles the "Fake Price" logic: 
 * - Standard: 10,000 (Strike) -> 6,000 (Main)
 * - Offer: 6,000 (Strike) -> 3,900 (Main)
 */
export const getEditionPricing = (edition, activeOffer) => {
  if (!edition) return null;

  const offerKey = activeOffer?.offerKey;
  var hasSpecialOffer = offerKey && offerKey !== 'FRESH' && edition.offerPrices?.[offerKey];

  // // --- BOGO check: only leads whose sinceDT date is 2026-03-18 are eligible ---
  // const isBogo = (() => {
  //     try {
  //         const allDataRaw = localStorage.getItem('allData');
  //         if (!allDataRaw) return false;
  //         const allData = JSON.parse(allDataRaw);
  //         const sinceDTStr = allData?.sinceDTStr;
  //         if (!sinceDTStr) return false;
  //         const sinceDateStr = sinceDTStr.split(' ')[0]; 

  //         const d = new Date();
  //         const todayStr = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  //         return sinceDateStr === '2026-03-18' && todayStr === '2026-03-19';
  //     } catch { return false; }
  // })();


  const isBogo = activeOffer?.offerKey === 'SPLBOGO';

  if (isBogo) {
    hasSpecialOffer = false
  }
  // --- STEP 1: Determine MAIN Price ---
  let mainPrice = edition.baseAmtStr;
  if (hasSpecialOffer) {
    const data = edition.offerPrices[offerKey];
    mainPrice = activeOffer.isWHFB ? data.wh : data.other;
  } else if (edition.baseAmtAfterDescStr) {
    mainPrice = edition.baseAmtAfterDescStr;
  }

  // --- STEP 2: Determine STRIKE Price (The "Smooth" Logic) ---
  let strikePrice = null;
  if (hasSpecialOffer) {
    // If an offer is on, we strike the "Base/Renewal" price (e.g. 6,000)
    strikePrice = edition.baseAmtStr;
  } else if (edition.baseAmtAfterDescStr) {
    // If a fixed discount is on, we strike the "Base" price (e.g. 3,000)
    strikePrice = edition.baseAmtStr;
  } else if (edition.stdAmt > edition.baseAmt) {
    // Otherwise, we strike the "Standard/Fake" price (e.g. 10,000)
    strikePrice = edition.stdAmtStr;
  }

  // --- STEP 3: Finalize ---
  const mNum = parseInt(mainPrice.replace(/,/g, ''));
  const sNum = strikePrice ? parseInt(strikePrice.replace(/,/g, '')) : mNum;

  return {
    mainPrice,
    strikePrice: sNum > mNum ? strikePrice : null,
    discountPercent: sNum > mNum ? Math.round(((sNum - mNum) / sNum) * 100) : 0,
    isOffer: hasSpecialOffer,
    isBogo,
    offerLabel: hasSpecialOffer ? activeOffer.label : '',
    basePrice: edition.baseAmtStr,
    stdPrice: edition.stdAmtStr
  };
};

// --- Update getOfferPrice to call the new helper for backward compatibility if needed ---
export const getOfferPrice = (edition, activeOffer) => {
  const p = getEditionPricing(edition, activeOffer);
  return { displayPrice: p.mainPrice, stdPrice: p.strikePrice, rnwlPrice: edition.baseAmtStr };
};